import React from "react";

function TeacherProfilePage() {
	return (
		<div>
			<h1>Hi Teacher</h1>
		</div>
	);
}

export default TeacherProfilePage;
